(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    (() => {

  const addM2Suffix = (priceBlock) => {

    if (!priceBlock) return;

    priceBlock.querySelectorAll('.price').forEach((priceElement) => {

      if (priceElement.dataset.m2Added === 'true') {
        return;
      }

      priceElement.dataset.m2Added = 'true';

      const suffix = document.createElement('span');

      suffix.textContent = ' per m2';

      priceElement.appendChild(suffix);

    });

  };


  const checkProduct = (priceBlock) => {

    const handle = priceBlock.dataset.productHandle;

    if (!handle) {
      return;
    }


    if (priceBlock.dataset.m2Checked === 'true') {
      return;
    }

    priceBlock.dataset.m2Checked = 'true';


    fetch(
      `${window.Shopify.routes.root}products/${encodeURIComponent(handle)}.js`
    )

      .then((response) => {

        if (!response.ok) {
          throw new Error(
            `Product request failed: ${response.status}`
          );
        }

        return response.json();

      })

      .then((product) => {

        if (!Array.isArray(product.tags)) {
          return;
        }


        if (!product.tags.includes('m2-per-3')) {
          return;
        }


        addM2Suffix(priceBlock);


        const observer = new MutationObserver(() => {

          addM2Suffix(priceBlock);

        });


        observer.observe(priceBlock, {

          childList: true,

          subtree: true

        });

      })

      .catch((error) => {

        console.error(
          'Muré Ciré - fout bij controleren producttag m2-per-3:',
          error
        );

      });

  };


  const init = () => {

    document
      .querySelectorAll(
        'product-price[data-product-handle]'
      )
      .forEach((priceBlock) => {

        checkProduct(priceBlock);

      });

  };


  init();


  document.addEventListener(
    'DOMContentLoaded',
    init
  );


  document.addEventListener(
    'shopify:section:load',
    init
  );


  document.addEventListener(
    'shopify:section:reorder',
    init
  );


  const pageObserver = new MutationObserver(() => {

    init();

  });


  pageObserver.observe(document.body, {

    childList: true,

    subtree: true

  });

})();
  } catch(e) { console.error(e); }
})();

})();
